"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
var Language;
(function (Language) {
    Language["EN_US"] = "EN-US";
})(Language = exports.Language || (exports.Language = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFuZ3VhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbGFuZ3VhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxRQUVYO0FBRkQsV0FBWSxRQUFRO0lBQ2hCLDJCQUFlLENBQUE7QUFDbkIsQ0FBQyxFQUZXLFFBQVEsR0FBUixnQkFBUSxLQUFSLGdCQUFRLFFBRW5CIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gTGFuZ3VhZ2Uge1xuICAgIEVOX1VTID0gJ0VOLVVTJyxcbn1cbiJdfQ==